import HubPage from '../../components/HubPage';
export default function HRHub() { return <HubPage hubKey="hr" />; }
